'use client';
import { Textfield as BaseTextfield } from '@lichtblick/photon/molecules/legacy-textfield/textfield';
import { withValidation } from './Form.helpers';
export const Textfield = withValidation(BaseTextfield);

//# sourceMappingURL=Textfield.js.map